import { useCallback } from 'react';

export default function useOnFormChange(onChange: (value: Record<string, unknown>) => void) {
  return useCallback((value: any, name: string) => onChange({ [name]: value }), [onChange]);
}
